import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button, Modal } from "react-bootstrap";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import uuidv4 from "uuid/v4";
import {
  createCorrection,
  downloadSpreadsheet,
  getJobData,
} from "../../../docuclipper/api";
import {
  DocuclipperToken,
  Document,
  Fragment,
  JobDocument,
} from "../../../docuclipper/DocuclipperTypes";
import store, { ReduxState } from "../../../redux";
import { createAlert, CreateAlertFn } from "../../../redux/reducers/Alerts";
import { setDocument, setFile, SetFileFn } from "../../../redux/reducers/Files";
import { fetchTotals } from "../../../redux/reducers/Reconciler";
import { clearJob, setJob } from "../../../redux/reducers/TemplateField";
import AlertBanner from "../../Docuclipper/AlertBanner/AlertBanner";
import DocuClipperTable from "../../Docuclipper/DocuClipperTable";
import TrackedButton from "../../Docuclipper/TrackedButton";
import DownloadAsAdminButton from "../Admin/DownloadAsAdminButton";
import RegionsReadOnly from "../ExtractSingle/v2/RegionsReadOnly";
import { ReconciledBadge } from "./ReconciledBadge";
import { ReconcilerByDocument } from "./Reconciler";

type Props = {
  jobId: number;
  location: {
    search: string;
    pathname: string;
  };
};

type ReduxProps = {
  setFile: SetFileFn;
  createAlert: CreateAlertFn;
  token: DocuclipperToken;
  jobDocuments: JobDocument[];
  reconcilerState: ReduxState["Reconciler"];
};

type State = {
  data: any[];
  pages: number;
  loading: boolean;
  modalOpened: { [key: number]: boolean };
  selectedDocumentIndex: number | null;
};

class JobDataTable extends React.Component<
  Props & ReduxProps & RouteComponentProps,
  State
> {
  private table: any;

  constructor(props) {
    super(props);
    this.state = {
      data: [],
      pages: 0,
      loading: true,
      modalOpened: {},
      selectedDocumentIndex: null,
    };
    this.fetchData = this.fetchData.bind(this);
    this.requestData = this.requestData.bind(this);
    this.toggle = this.toggle.bind(this);
    this.loadFragments = this.loadFragments.bind(this);
    this.table = React.createRef();
  }

  public componentWillUnmount() {
    store.dispatch(clearJob());
  }

  public render() {
    const { jobDocuments, reconcilerState } = this.props;
    return (
      <DocuClipperTable
        syncUrl={false}
        defaultPageSize={20}
        defaultSorted={[]}
        defaultFiltered={[]}
        fetchData={(x) =>
          this.fetchData({ pageSize: x.limit, page: x.offset / x.limit }, null)
        }
        columns={[
          {
            Header: "Documents",
            accessor: "document",
            headerStyle: {
              fontWeight: "bold",
            },
            Cell: (row) => {
              const selectRow = () => {
                this.setState({ selectedDocumentIndex: row.index }, () => {
                  if (this.state.selectedDocumentIndex !== null) {
                    const { document, fragments } =
                      this.state.data[this.state.selectedDocumentIndex];
                    this.loadFragments(document, fragments);
                    this.toggle(row.index, () => null);
                  }
                });
              };

              const { token } = this.props;
              const showDownload =
                (token &&
                  token.permissions &&
                  token.permissions.includes("READ_DB_TABLES")) ||
                (token &&
                  token.permissions &&
                  token.permissions.includes("SUPPORT_TOOL"));

              const exportData = (where: "xlsx" | "csv" | "qbo") => {
                return downloadSpreadsheet(
                  this.props.jobId,
                  "FieldsToExcel1",
                  where,

                  true,
                  [row.original.document.id],
                  {},
                  []
                )
                  .then((data) => {
                    saveAs(
                      data,
                      `${row.original.document.originalname}-docuclipper.${where}`
                    );
                    this.props.createAlert({
                      type: "success",
                      message: [
                        `Data exported correctly. Check your Downloads folder.`,
                      ],
                      timeout: 0,
                    });
                  })
                  .catch((err) => {
                    this.props.createAlert({
                      type: "error",
                      message: err.message || "Error exporting data.",
                      timeout: 0,
                    });
                  });
              };
              const { jobId } = this.props;

              return (
                <div key={row.index}>
                  <TrackedButton
                    className="text-left btn--job-data-document-view-detail"
                    action="jobDataTableAccordionClick"
                    variant="link"
                    id={`toggler-${row.value ? row.value.id : uuidv4()}`}
                    style={{
                      marginBottom: "1rem",
                      width: showDownload ? "65%" : "70%",
                    }}
                    onClick={selectRow}
                  >
                    {row.value ? row.value.originalname || "" : ""}
                  </TrackedButton>

                  <Modal
                    size="xl"
                    show={this.state.modalOpened[row.index]}
                    onHide={() => this.toggle(row.index, () => null)}
                  >
                    <Modal.Header closeButton={true}>
                      {row.original.document.originalname}
                    </Modal.Header>
                    <Modal.Body>
                      <div className="mt-2 mb-2">
                        <AlertBanner />
                      </div>
                      <RegionsReadOnly />
                    </Modal.Body>
                  </Modal>
                  {showDownload && (
                    <>
                      <DownloadAsAdminButton
                        documentId={row.original.document.id}
                      />
                    </>
                  )}
                  <>
                    <Button
                      className="mx-2"
                      variant="link"
                      onClick={() => exportData("xlsx")}
                    >
                      <FontAwesomeIcon icon="download" />
                      <span className="ml-1">xlsx</span>
                    </Button>
                    <Button
                      className="mx-2"
                      variant="link"
                      onClick={() => exportData("csv")}
                    >
                      <FontAwesomeIcon icon="download" />
                      <span className="ml-1">csv</span>
                    </Button>

                    {/* <div className="p-2" style={{ display: "inline-block" }}>
                      <ReconciledBadge
                        type="document"
                        documentId={row.original.document.id}
                      />
                    </div> */}

                    {/* <Accordion defaultActiveKey="0">
                      <Accordion.Item eventKey="0">
                        <Accordion.Header>Field Breakdown</Accordion.Header>

                        <Accordion.Body> */}
                    {false && (
                      <ReconcilerByDocument
                        totals={
                          reconcilerState && reconcilerState.totalsByDocumentId
                            ? reconcilerState.totalsByDocumentId[
                                row.original.document.id
                              ] || {}
                            : {}
                        }
                        badTransactions={
                          reconcilerState &&
                          reconcilerState.badTransactionsByDocumentId
                            ? reconcilerState.badTransactionsByDocumentId[
                                row.original.document.id
                              ] || []
                            : []
                        }
                        byDay={
                          reconcilerState && reconcilerState.byDayByDocumentId
                            ? reconcilerState.byDayByDocumentId[
                                row.original.document.id
                              ] || []
                            : []
                        }
                        createCorrection={(name, r, c, newValue) =>
                          createCorrection(
                            jobId as any,
                            row.original.document.id,
                            name,
                            r,
                            c,
                            newValue.toString(),
                            row.original.included,
                            false,
                            false
                          )
                            .then(() => {
                              store.dispatch(
                                createAlert({
                                  message: "Line corrected successfully",
                                  timeout: 0,
                                  type: "success",
                                })
                              );
                              store.dispatch(fetchTotals());
                            })
                            .catch((err) => {
                              store.dispatch(
                                createAlert({
                                  message: "Error correcting line",
                                  timeout: 0,
                                  type: "error",
                                })
                              );
                            })
                        }
                      />
                    )}
                    {/* </Accordion.Body>
                      </Accordion.Item>
                    </Accordion> */}
                    {/* <Button
                          className="mx-2"
                          variant="link"
                          onClick={() => exportData("qbo")}
                        >
                          qbo
                        </Button> */}
                  </>
                </div>
              );
            },
          },
        ]}
        tableId="jobDataTable2"
        externalLoading={false}
      />
    );
  }

  private toggle(index, cb) {
    this.setState(
      (prevState) => ({
        modalOpened: {
          ...prevState.modalOpened,
          [index]: !prevState.modalOpened[index],
        },
      }),
      cb
    );
  }
  private requestData(pageSize, page, sorted, filtered) {
    return getJobData({
      jobId: this.props.jobId,
      offset: pageSize * page,
      limit: pageSize,
    });
  }

  private fetchData(state, instance) {
    // Whenever the table model changes, or the user sorts or changes pages, this method gets called and passed the current table model.
    // You can set the `loading` prop of the table to true to use the built-in one or show you're own loading bar if you want.
    this.setState({ loading: true });
    // Request the data however you want.  Here, we'll use our mocked service we created earlier
    return this.requestData(
      state.pageSize,
      state.page,
      state.sorted,
      state.filtered
    )
      .then((res) => {
        // Now just get the rows of data to your React Table (and update anything else like total pages or loading)
        this.setState(
          {
            data: res.rows,
            pages: Math.ceil(res.count / state.pageSize),
            loading: false,
          },
          () => {
            if (this.state.selectedDocumentIndex !== null) {
              const { document, fragments } =
                res.rows[this.state.selectedDocumentIndex];
              this.loadFragments(document, fragments);
            }
          }
        );
        return res;
      })
      .catch((err) => this.setState({ loading: false }));
  }

  private loadFragments(document: Document, fragments: Fragment[]) {
    // const { setFile, setTemplate, setNumPages } = this.props;

    store.dispatch(setJob({ id: this.props.jobId } as any));
    store.dispatch(setDocument({ document: { ...document } }));

    // setFile({ file: { document } as any });
    // setNumPages(document.numPages);
    // const template: Template = {
    //   type: "FreeForm",
    //   template: JSON.stringify({
    //     rectangles: fragments.map((r) => ({
    //       x0: r.x0,
    //       x1: r.x1,
    //       y0: r.y0,
    //       y1: r.y1,
    //       pageNumber: parseInt(r.pageNumber.toString(), 10),
    //       toolType: r.toolType,
    //       name: r.fieldName,
    //       improvedText: r.improvedText,
    //       editedText: r.editedText,
    //       extractedText: r.extractedText,
    //       fragment: {
    //         id: r.id,
    //         rating: r.rating,
    //       },
    //     })),
    //   }),
    // } as any;
    // setTemplate(template);
  }
}

const mapStateToProps = (state: ReduxState) => ({
  token: state.Auth.token,
  jobDocuments: state.JobDocument.data,
  reconcilerState: state.Reconciler,
});

export default connect(mapStateToProps, {
  setFile,
  createAlert,
})(withRouter(JobDataTable));
